import { ApiPath } from 'enums';
import { Get, Post, Put } from 'utils';

export const getCustomers = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Customer}`, query);
  return res.data;
};

export const createCustomer = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Customer}`, body);
  return res.data;
};

export const updateCustomer = async ({ customerId, ...body }) => {
  const res = await Post(`${ApiPath.Customer}/update`, { ...body, customerId });
  return res.data;
};

export const getCustomerAccounts = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Customer}/account`, query);
  return res.data;
};

export const getCustomerById = async ({ customerId }) => {
  const res = await Get(`${ApiPath.Customer}/detail/${customerId}`);
  return res.data;
};

export const createCustomerAccount = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Customer}/account`, body);
  return res.data;
};

export const updateCustomerAccount = async ({ customerAccountId, ...body }) => {
  const res = await Put(`${ApiPath.Customer}/account/${customerAccountId}`, body);
  return res.data;
};

export const generateCustomerClaim = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Customer}/claims/generate`, body);
  return res.data;
};

export const getCustomerClaimsByCustomerAccount = async ({ customerAccountId }) => {
  const res = await Get(`${ApiPath.Customer}/claims/customer-account/${customerAccountId}`);
  return res.data;
};

export const updateCustomerClaim = async ({ customerClaimId, ...body }) => {
  const res = await Put(`${ApiPath.Customer}/claims/${customerClaimId}`, body);
  return res.data;
};

export const getCustomerAccountByNumber = async ({ customerAccountNumber }) => {
  const res = await Get(`${ApiPath.Customer}/account/customer-account/${customerAccountNumber}`);
  return res.data;
};

export const getCustomerClaims = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Customer}/claims`, query);
  return res.data;
};
